import 'jcarousel';
import getStaticImagesUrls from '@/js/common/Domain/Service/getStaticImagesUrls';
import trackImageErrors from '@/js/common/Domain/Service/trackImageErrors';

export default function initStaticHotelsCarousel($hotelsList) {
    $('.js-images-carousel', $hotelsList).jcarousel({
        list: '.list',
        items: 'li',
        wrap: 'both',
        vertical: false,
    }).on('jcarousel:visiblein', 'li', function () {
        const $element = $('a:not(.btn)', this);
        const imageUrl = $element.data('src');
        if (imageUrl) {
            trackImageErrors([imageUrl]);
            $element.css('background-image', `url("${imageUrl}")`);
        }
    });

    $('.js-images-carousel-control-prev', $hotelsList).jcarouselControl({
        target: '-=1',
    });

    $('.js-images-carousel-control-next', $hotelsList).jcarouselControl({
        target: '+=1',
    });

    const imagesUrls = getStaticImagesUrls({
        $el: $hotelsList.find('ul.imagesHtml').find('li:first-child').find('a'),
    });
    trackImageErrors(imagesUrls);
}
